var height_calculator = (function( $ ) {

	var _init = function() {
		const toggle = document.getElementById( 'unitsToggle' );

		if ( toggle ) {
			toggle.addEventListener( 'change', function() {
				const url = new URL( window.location );

				if ( this.checked ) {
					url.searchParams.set( 'units', 'imperial' );
				} else {
					url.searchParams.delete( 'units' );
				}

				window.location.href = url.toString();
			} );
		}
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = height_calculator;